module.exports = __webpack_public_path__ + "static/img/top1_i4_nav.13ee5e7d.png";